if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.handleThumbnailClick = this.handleThumbnailClick.bind(this);
        this.handleViewerSlideChange = this.handleViewerSlideChange.bind(this);
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.initializeMediaSlider();
        this.showActiveMedia();
      }

      initializeMediaSlider() {
        this.viewer?.initPages?.();
        this.thumbnails?.initPages?.();

        if (this.viewer && this.viewer !== this.boundViewer) {
          this.boundViewer?.removeEventListener('slideChanged', this.handleViewerSlideChange);
          this.viewer.addEventListener('slideChanged', this.handleViewerSlideChange);
          this.boundViewer = this.viewer;
        }

        if (this.thumbnailRail && !this.thumbnailRail.dataset.modalBound) {
          this.thumbnailRail.addEventListener('click', this.handleThumbnailClick);
          this.thumbnailRail.dataset.modalBound = 'true';
        }

        if (this.layout && !this.layout.dataset.modalPointerBound) {
          this.layout.addEventListener('pointerup', (event) => event.stopPropagation());
          this.layout.dataset.modalPointerBound = 'true';
        }
      }

      showActiveMedia() {
        if (this.viewer) {
          this.setActiveMediaById(this.openedBy.getAttribute('data-media-id'));
          return;
        }

        this.querySelectorAll(
          `.product-media-modal__content > [data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(
          `.product-media-modal__content > [data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`
        );
        if (!activeMedia) return;
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }

      handleThumbnailClick(event) {
        const thumbnailButton = event.target.closest('[data-target] button');
        if (!thumbnailButton) return;

        event.preventDefault();
        const thumbnailItem = thumbnailButton.closest('[data-target]');
        if (!thumbnailItem) return;

        this.setActiveMediaById(thumbnailItem.dataset.target);
      }

      handleViewerSlideChange(event) {
        const currentSlide = event.detail.currentElement;
        if (!currentSlide?.dataset?.mediaId) return;

        this.updateActiveSlideState(currentSlide.dataset.mediaId);
        this.playActiveMedia(currentSlide);
      }

      setActiveMediaById(mediaId) {
        const activeSlide =
          this.querySelector(`.product-media-modal__slide[data-media-id="${mediaId}"]`) ||
          this.querySelector('.product-media-modal__slide[data-media-id]');
        if (!activeSlide) return;

        this.updateActiveSlideState(activeSlide.dataset.mediaId);
        this.viewer?.setSlidePosition?.(activeSlide.offsetLeft);
        this.playActiveMedia(activeSlide);
      }

      updateActiveSlideState(mediaId) {
        this.querySelectorAll('.product-media-modal__slide[data-media-id]').forEach((slide) => {
          slide.classList.toggle('is-active', slide.dataset.mediaId === mediaId);
        });

        this.querySelectorAll('.product-media-modal__thumbnail-item button').forEach((button) => {
          button.removeAttribute('aria-current');
        });

        const activeThumbnail = this.querySelector(`.product-media-modal__thumbnail-item[data-target="${mediaId}"]`);
        const activeThumbnailButton = activeThumbnail?.querySelector('button');
        activeThumbnailButton?.setAttribute('aria-current', 'true');

        if (!activeThumbnail || !this.thumbnails) return;
        if (this.thumbnails.isSlideVisible?.(activeThumbnail, 10)) return;

        this.thumbnails.setSlidePosition?.(activeThumbnail.offsetLeft);
      }

      playActiveMedia(activeSlide) {
        window.pauseAllMedia();

        const deferredMedia = activeSlide.querySelector('deferred-media, product-model');
        const activeMediaContent = deferredMedia?.querySelector('template')?.content;
        if (deferredMedia && activeMediaContent?.querySelector('.js-youtube')) {
          deferredMedia.loadContent();
        }
      }

      get layout() {
        return this.querySelector('.product-media-modal__layout');
      }

      get viewer() {
        return this.querySelector('[id^="ProductModalViewer-"]');
      }

      get thumbnailRail() {
        return this.querySelector('[id^="Slider-ProductModalThumbnails-"]');
      }

      get thumbnails() {
        return this.querySelector('[id^="ProductModalThumbnails-"]');
      }
    }
  );
}
